// extracted by mini-css-extract-plugin
export default {"header":"PageHeader_header__J-fci","title":"PageHeader_title__v5PbZ","subtitle":"PageHeader_subtitle__sZ1eE","small":"PageHeader_small__txGlz"};